// refundDraft.js — create the refund drafted in the wizard's Refund step, once the client
// exists. Uses the client's saved details so the refund always matches the client record.
import { api } from "../api";

export async function createDraftRefund(client, draft) {
  if (!client?._id || !draft) return null;
  return api.post("/crm/refunds", {
    ...draft,
    client: client._id,
    clientName: client.fullName || draft.clientName,
    email: client.email || draft.email,
    phone: client.phone || draft.phone || undefined,
    country: client.countryOfResidence || draft.country || undefined,
  });
}
